import { render, staticRenderFns } from "./AccidentAnalysis.vue?vue&type=template&id=0a12d70a&scoped=true&"
import script from "./AccidentAnalysis.vue?vue&type=script&lang=js&"
export * from "./AccidentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AccidentAnalysis.vue?vue&type=style&index=0&id=0a12d70a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12d70a",
  null
  
)

export default component.exports